import { TemplateResult, html } from 'lit';
import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-teaser-card.css.lit';

/**
 * The OutlineTeaserCard component
 * @element outline-teaser-card
 */
@customElement('outline-teaser-card')
export class OutlineTeaserCard extends OutlineElement {
  static styles = [componentStyles];

  slots = new SlotsController(this);

  render(): TemplateResult {
    return html`
      <div class="teaser-card">
        <div class="container">
          ${this.slots.conditionalSlot('eyebrow', false)}
          ${this.slots.conditionalSlot('title', false)}
          ${this.slots.conditionalSlot('date', false)}
        </div>
        ${this.slots.conditionalSlot('description', false)}
      </div>
    `;
  }
}
